import { supabase, forceSignOut } from '../services/backendService';
import logger from "@/utils/logger";

export const authenticatedFetch = async (url: string, options: RequestInit = {}): Promise<Response> => {
    const { data: { session }, error } = await supabase.auth.getSession();

    if (error || !session?.access_token) {
        logger.warn("[apiClient] No session found. Triggering logout.");
        await forceSignOut();
        throw new Error("UNAUTHORIZED");
    }

    const headers = new Headers(options.headers || {});
    headers.set('Authorization', `Bearer ${session.access_token}`);

    let response = await fetch(url, { ...options, headers });

    if (response.status === 401) {
        logger.warn("[apiClient] 401 received. Attempting to refresh token...");
        const { data: refreshData, error: refreshError } = await supabase.auth.refreshSession();

        if (refreshError || !refreshData.session?.access_token) {
            logger.error("[apiClient] Token refresh failed. Logging out.");
            await forceSignOut();
            throw new Error("UNAUTHORIZED_REFRESH_FAILED");
        }

        // Retry once with new token
        headers.set('Authorization', `Bearer ${refreshData.session.access_token}`);
        response = await fetch(url, { ...options, headers });

        if (response.status === 401) {
            logger.error("[apiClient] 401 received after refresh. Logging out.");
            await forceSignOut();
            throw new Error("UNAUTHORIZED_PERMANENT");
        }
    }

    return response;
};
